<template>
    <div class="buttons-container">
        <el-tooltip
            v-if="hasSimulation && currentSimulation.status === 'COMPLETED'"
            class="item" 
            effect="light"
            :content="tooltips.dataView" 
            placement="top"
            :visible-arrow="false"
        >
            <el-button
                :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                round
                :loading="reportLoading"
                @click.stop.prevent="goToDataView(buttonConfig.entity, data.uid)"
            >
                <v-icon
                    name="eye"
                ></v-icon>
            </el-button>
        </el-tooltip>
        <el-tooltip
            v-if="buttonConfig.entity === 'site' && hasSimulation"
            class="item"
            effect="light"
            :content="reportIsReady?tooltips.downloadReport:tooltips.generateReport"
            placement="top"
            :visible-arrow="false"
        >
            <el-button
                :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                round
                :loading="reportLoading"
                @click.stop.prevent="reportIsReady?downloadReport():generateReport()"
            >
                <v-icon
                    v-if="reportIsReady"
                    name="download"
                ></v-icon>
                <div
                    v-if="reportLoading"
                >
                    Génération du rapport en cours...
                </div>
                <v-icon
                    v-else-if="!reportIsReady"
                    name="chart-pie"
                ></v-icon>
             </el-button>
         </el-tooltip>
        <el-tooltip
            v-if="buttonConfig.entity === 'site'"
            class="item" 
            effect="light" 
            :content="tooltips.runSimulation" 
            placement="top"
            :visible-arrow="false"
        >
            <el-button
                :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                round
                :disabled="!allMeasureFilesLoaded"
                :loading="simulationLoading"
                @click.stop.prevent="openRangeModal()"
            >
                <v-icon
                    name="calculator"
                ></v-icon>
                <div
                    v-if="simulationLoading"
                >
                    Calculs en cours...
                </div>
            </el-button>
        </el-tooltip>
        <template
            v-if="buttonConfig.createForm !== undefined">
            <el-button
                v-if="typeof buttonConfig.createForm === 'function'"
                :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                round
                icon="el-icon-plus"
                @click.stop.prevent="buttonConfig.createForm()">
            </el-button>
            <el-dropdown
                v-else
                @command="handleCommand"
                class="dropdown-create-action"
            >
                <el-button
                    :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                    icon="el-icon-plus"
                    round
                >
                </el-button>
                <el-dropdown-menu 
                    slot="dropdown"
                >
                    <el-dropdown-item
                        v-for="(action, index) in Object.keys(buttonConfig.createForm)"
                        :key="index"
                        :command="action"    
                    >
                        {{ action }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
    
        </template>
        <el-tooltip
            class="item"
            effect="light"
            :content="tooltips.importData"
            placement="top"
            :visible-arrow="false"
        >
            <el-button
                v-if="data.energy_meter !== 'virtual_meter'"
                :class="['tile-button', getButtonClass(buttonConfig.entity)]"
                round
                icon="el-icon-upload"
                @click.stop.prevent="openSimulationModal()"
            ></el-button>
        </el-tooltip>
        <el-button
            :class="['tile-button', getButtonClass(buttonConfig.entity)]"
            round
            icon="el-icon-edit"
            @click.stop.prevent="buttonConfig.editForm()"
        ></el-button>
        <el-button
            :class="['tile-button', getButtonClass(buttonConfig.entity)]"
            round
            icon="el-icon-delete"
            @click.stop.prevent="deleteItem()"
        ></el-button>
        <el-dialog
            v-if="displayRangeModal"
            :visible.sync="displayRangeModal"
            :show-close="false"
            :modal-append-to-body="false"
            width="50"
            class="dialog"
            title="Plage temporelle de l'analyse"
            center
            ref="newSimulationDialog"
        >
            <SimulationRangeModal
                @close-range-modal="closeRangeModal"
                @refresh-data="refreshData()"
                @simulationCreated="watchSimulation"
            ></SimulationRangeModal>
        </el-dialog>

        <el-dialog
            v-if="displaySimulationModal"
            :visible.sync="displaySimulationModal"
            :show-close="false"
            :modal-append-to-body="false"
            class="dialog"
            title="Charger les mesures"
            center
            ref="newSimulationDialog"
        >
            <SimulationModal
                :item="data"
                :model="currentModel"
                @close-simulation-modal="closeSimulationModal"
                @refresh-data="refreshData()"
            ></SimulationModal>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SimulationModal from '@/components/partials/simulation/SimulationModal.vue';
import SimulationRangeModal from '@/components/partials/simulation/SimulationRangeModal.vue';
    export default {
        name: 'ActionButtons',
        components:{
            SimulationModal,
            SimulationRangeModal
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        data(){
            return {
                displayRangeModal: false,
                displaySimulationModal: false,
                simulationLoading: false,
                reportLoading: false,
                simulationCompleted: false,
                tooltips:{
                    dataView: 'Prévisualisation des résultats',
                    generateReport: 'Génération du rapport',
                    downloadReport: 'Télécharger le rapport',
                    runSimulation: 'Lancer une simulation',
                    importData: 'Charger les mesures',
                }
            }
        },
        computed:{
            ...mapGetters(['currentSite', 'allMeasureFilesLoaded', 'hasSimulation', 'currentSimulation']),
            currentModel(){
                if(this.isWorkshop || this.isZone){
                    return 'area'
                }else if (this.isMotor || this.isMachine){
                    return 'equipment'
                }else{
                    return 'site'
                }
            },
            reportIsReady(){
                return this.currentSimulation 
                && this.currentSimulation.pptx_file !== null;
            },
            isWorkshop() {
                return this.data.entity === 'workshop';
            },
            isZone() {
                return this.data.entity === 'zone';
            },
            isMotor() {
                return this.data.equipment_type && this.data.equipment_type === 'motor';
            },
            isMachine() {
                return this.data.equipment_type && this.data.equipment_type === 'machine';
            },
            buttonConfig() {
                switch (this.data.entity) {
                    case 'zone':
                        return {
                            createForm: this.createEquipmentForm,
                            editForm: this.editZoneForm,
                            confirmLabel: 'cette zone',
                            delete: { model: 'area' },
                            entity: 'zone'
                        };
                    case 'workshop':
                        return {
                            createForm: {
                                'Zone': this.createZoneForm,
                                'Equipement': this.createEquipmentForm
                            },
                            editForm: this.editWorkshopForm,
                            confirmLabel: 'cet atelier',
                            delete: { model: 'area' },
                            entity: 'workshop'
                        };
                    case 'equipment':
                        return {
                            editForm: this.editEquipmentForm,
                            confirmLabel: this.isMachine ? 'cette machine' : 'ce moteur',
                            delete: { model: 'equipment' },
                            entity: this.isMachine ? 'machine' : 'motor',
                        };
                    default:
                        return {
                            editForm: this.openSiteForm,
                            createForm: this.openAreaForm,
                            confirmLabel: 'ce site',
                            delete: { model: 'site' },
                            entity: 'site',
                        };
                }
            },
        },
        watch: {
            simulationLoading: {
                handler(newVal){
                    if(newVal === false){
                        this.$emit('refreshTree');
                    }
                }
            }
        },
        methods: {
            goToDataView(entity, uid){
                this.$router.push({ name: 'DataView', params: { 
                    entity: entity, 
                    uid: uid,
                    start_date: this.currentSimulation.start_date,
                    end_date: this.currentSimulation.end_date
                } });
            },
            openSimulationModal(){
                this.displaySimulationModal = true;
            },  
            closeSimulationModal(){
                this.refreshData()
                this.displaySimulationModal = false;
            },
            openRangeModal(){
                this.displayRangeModal = true;
            },
            closeRangeModal(){
                this.displayRangeModal = false;
            },
            handleCommand(command){
                this.buttonConfig.createForm[command]();
            },
            createZoneForm(){
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'zone',
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.data.uid
                    }
                });
            },
            createEquipmentForm(){
                this.$router.push({
                    name: 'Equipment',
                    params: {
                        siteUid: this.currentSite.uid,
                        parentAreaUid: this.data.uid
                    }
                });
            },
            editZoneForm(){
                this.$store.commit('SET_CURRENT_AREA', {...this.data});
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'zone',
                        siteUid: this.currentSite.uid,
                    }
                });
            },
            editWorkshopForm() {
                this.$store.commit('SET_CURRENT_AREA', {...this.data});
                this.$router.push({
                    name: 'Area',
                    params: {
                        areaType: 'workshop',
                        siteUid: this.currentSite.uid,
                    }
                });
            },
            editEquipmentForm() {
                this.$store.commit('SET_CURRENT_EQUIPMENT', {...this.data});
                this.$router.push({
                    name: 'Equipment',
                    params: {
                        areaType: 'equipment',
                        siteUid: this.currentSite.uid,
                    }
                });
            },
            openAreaForm() {
                this.$router.push({ 
                    name: 'Area',
                    params: { 
                        siteUid: this.currentSite.uid,
                        areaType: 'workshop',
                        parentAreaUid: null
                    }
                });
            },
            openSiteForm() {
                this.$router.push({ 
                    name: 'Site', 
                    params: { siteUid: this.currentSite.uid } 
                });
            },
            deleteItem(){
                 this.$confirm(`Voulez-vous vraiment supprimer ${this.buttonConfig.confirmLabel} ?`, this.data.name, {
                    type: 'warning',
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                })
                .then(() =>{
                    this.$store.dispatch('patchItem',{
                        item:{
                            archived: true,
                            url: this.data.url,
                            uid: this.data.uid
                        },
                        model: this.buttonConfig.delete.model,
                        url: this.$store.state.api.meta.listModels[this.buttonConfig.delete.model].url,
                    }).then(() => {
                        this.$emit('refreshTree');
                        this.$notify({
                            title: 'Success',
                            message: `${this.data.name} à été supprimé.`,
                            type: 'success'
                        });
                    }).catch((error) => {
                        this.$notify({
                            title: 'Error',
                            message: `Erreur lors de la suppression de ${this.data.name}.`,
                            type: 'error'
                        });
                    });
                })
                .catch(() => {
                    return;
                });
            },
            refreshData(){
                this.$emit('refreshTree');
            },
            getButtonClass(entity) {
                switch (entity) {
                case 'workshop':
                    return 'workshop';
                case 'zone':
                    return 'zone';
                case 'machine':
                    return 'machine';
                case 'motor':
                    return'motor';
                default:
                    return 'secondary';
                }
            },
            watchSimulation(simulation){
                this.simulationLoading = true;
                this.$store.dispatch('fundation/watchRequestStatus', {url: simulation.url}).then((res) => {
                    this.simulationLoading = false;
                    this.$store.commit('SET_CURRENT_SIMULATION', res.data);
                    this.$notify({
                        title: 'Success',
                        message: 'La simulation est terminée.',
                        type: 'success'
                    });
                    this.$emit('refreshTree');
                }).catch((error) => {
                    this.simulationLoading = false;
                    this.$notify({
                        title: 'Error',
                        message: error.data.verbose_status,
                        type: 'error'
                    });
                });
            },
            generateReport(){
                this.reportLoading = true;
                this.$store.dispatch('patchItem', {
                    item: {
                        url: this.currentSite.url,
                        uid: this.currentSite.uid,
                        pptx_status: 'PENDING',
                    },
                    model: 'site',
                }).then(() => {
                    this.$store.dispatch('fundation/watchRequestStatus', {url: this.currentSite.url, fieldToWatch: 'pptx_status'})
                    .then((res) => {
                        this.reportLoading = false;
                        this.$emit('refreshTree');
                        this.$notify({
                            title: 'Success',
                            message: 'Le rapport a été généré avec succès.',
                            type: 'success'
                        });
                    }).catch((error) => {
                        this.reportLoading = false;
                        this.$notify({
                            title: 'Error',
                            message: error.data.pptx_verbose_status,
                            type: 'error'
                        });
                    });
                }).catch((error) => {
                    this.reportLoading = false;
                    this.$notify({
                        title: 'Error',
                        message: error.data.verbose_status,
                        type: 'error'
                    });
                });
            },
            downloadReport(){
                if(this.currentSimulation && this.currentSimulation.pptx_file){
                    window.open(this.currentSimulation.pptx_file, '_blank');
                }
            }
        },
    }
</script>

<style lang="scss">
.dropdown-create-action {
    display: flex;
    margin-right: 10px;
    margin-left: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Synoptic/ActionButtons/Index.vue